import React from "react";
import { Control, useController } from "react-hook-form";

import TextareaBase, { TextareaProps } from "./TextareaBase";

interface TextareaControlledProps extends TextareaProps {
  control: Control;
}

const TextareaControlled: React.FC<TextareaControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });

  return <TextareaBase field={field} fieldState={fieldState} {...rest} />;
};

export default TextareaControlled;
